import { amountDisplay } from '../../util/helper';
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const StatisticsBanner = ({ totalSaving, title = 'totalBalance' }) => {
    const { t, language } = useLanguage();
    return (
        <section>
            <div className="custom-container">
                <div className="statistics-banner">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="total-amount">
                            <h3>{t(title)}</h3>
                            <h2>{amountDisplay(totalSaving, language)}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StatisticsBanner;
